import gql from 'graphql-tag';

export default gql`
    fragment OtherMusicSongs on Funeral {
        OtherMusicSongs {
            ID
            Name
            Artist
            Pathname
            SongSort
        }
    }
`;
